import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-capture-complete',
  templateUrl: './capture-complete.component.html',
  styleUrls: ['./capture-complete.component.scss']
})
export class CaptureCompleteComponent implements OnInit {

  constructor(private router: Router) {}

  ngOnInit(): void {

  }
}
